import $ from 'jquery';

function init() {
	const $shopTable = $( '.woocommerce-MyAccount-content #saved-cards' ).next( '.shop_table' );

	if ( $shopTable.length ) {
		$shopTable.addClass( 'shop_table_responsive' );
		$shopTable.find( 'tbody tr td:first-child' ).attr( 'data-title', 'Card' );
		$shopTable.find( 'tbody tr td:nth-child(2)' ).attr( 'data-title', 'Expires' ).addClass( 'saved-cards-table-row' );
		$shopTable.find( 'tbody tr td:nth-child(3)' ).addClass( 'saved-cards-table-last' );
	}
}

export default {
	init,
};
